import { EventStatus } from '@puzzlehq/sdk';

export const getStatusColor = (status: EventStatus) => {
  switch (status) {
    case EventStatus.Creating:
      return 'gray-500';
    case EventStatus.Pending:
      return 'purple';
    case EventStatus.Failed:
      return 'red';
    case EventStatus.Settled:
      return 'green';
  }
};
